import { useCallback, useState } from "react";

export const useExpandableContainers = () => {
  const [expandedContainers, setExpandedContainers] = useState<Record<string, boolean>>({});

  const expandContainer = useCallback((id: string, expanded?: boolean) => {
    setExpandedContainers(state => ({
      ...state,
      [id]: state?.[id] === undefined && expanded !== undefined ? !expanded : !state?.[id],
    }));
  }, []);

  return [expandedContainers, expandContainer] as const;
};
